module.exports = __webpack_public_path__ + "img/shop_friends.da6d374d.png";